import { Fetcher } from "openapi-typescript-fetch";
import { schemas } from "./decoder.ts";
import type { paths } from "./types.ts";

export const api = Fetcher.for<paths>();

export { schemas as apiDecoder };
